import { getAuthToken, constr_uri, handleLogin } from './apiClient'; 



const base64ToBlob = (base64String, contentType) => {
  const byteCharacters = atob(base64String);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: contentType });
};



const getFileFromBase64 = (base64Data, fileType, fileName) => {

    const blob = base64ToBlob(base64Data, fileType);
    const file = new File([blob], fileName, { type: fileType });

    return file;
}


export async function sendFileAsBinaryFormData( {file, typedoc, part, callback} ){

    const {type, name, size } = file; 

    const formData = new FormData();
    formData.append('file', getFileFromBase64(file.file)); // 'file' is the field name your backend expects
    // You can also append other data
    formData.append('description', JSON.stringify({ type, name, size }));
    formData.append('document', JSON.stringify({ typedoc, part}));

    fetch('/upload-endpoint', {
        method: 'POST',
        body: formData,
    })
    .then(response => response.json())
    .then(data => callback({result: 'success', typedoc, part, file: {type, name, size}}))
    .catch(error => callback({result: "error", error}));
   
}


export async function sendFileAsBinaryPOST( {_id, file, typedoc, part} ) {

       const {type, name, size } = file;

       const url = typedoc == "request" ? constr_uri('request/put_file') : 
       constr_uri('children/put_file');

       const file_str = file.file.split(',')[1];

       const out_data = { mtype: type, typedoc, part, name, size };

       if(typedoc == "request") out_data["req_id"] = _id;

       if(typedoc == "children") out_data["child_id"] = _id;

       const options = {
            headers:{
                finf: btoa( encodeURI ( JSON.stringify(out_data)) ),
                token: getAuthToken()
            },
            method: 'POST',
            body: getFileFromBase64(file_str, type, name),
        };



       try{

        const response = await fetch(url, options);

        if(response.status == 401) return handleLogin();

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        return data;

       } 
        catch(err) {

            return err;

       }   
   
}

export async function sendFileAsBinaryFormDataProgressInfo({ file, typedoc, part, callback, onProgress }) {
    const { type, name, size } = file;

    const formData = new FormData();
    formData.append('file', getFileFromBase64(file.file));
    formData.append('description', JSON.stringify({ type, name, size }));
    formData.append('document', JSON.stringify({ typedoc, part }));

    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();

        // Прогрес завантаження (upload)
        xhr.upload.addEventListener('progress', (event) => {
            if (event.lengthComputable && onProgress) {
                const percent = Math.round((event.loaded / event.total) * 100);
                onProgress({ loaded: event.loaded, total: event.total, percent });
            }
        });

        xhr.addEventListener('load', () => {
            if (xhr.status >= 200 && xhr.status < 300) {
                const data = JSON.parse(xhr.responseText);
                const result = { result: 'success', typedoc, part, file: { type, name, size } };
                callback(result);
                resolve(result);
            } else {
                const error = new Error(`HTTP ${xhr.status}`);
                callback({ result: 'error', error });
                reject(error);
            }
        });

        xhr.addEventListener('error', () => {
            const error = new Error('Network error');
            callback({ result: 'error', error });
            reject(error);
        });

        xhr.open('POST', '/upload-endpoint');
        xhr.send(formData);
    });
}
